import React from 'react';
import Type from 'prop-types';
import { useToggle } from 'react-use';
import { FormControl, TextField } from '@mui/material';
import { DateRange as DateRangeIcon } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, isValid } from 'date-fns';
import RangeCalendar from '../RangeCalendar/RangeCalendar';
import { getDateFnsLocale } from 'utils/date';
import { getInitialLocale, t } from 'utils/i18n';

const DATE_DISPLAY_FORMAT = 'dd.MM.yyyy';

const formatDisplayValue = (value) => {
  if (!Array.isArray(value)) return '';
  const [from, to] = value;
  const fromStr = from && isValid(new Date(from)) ? format(new Date(from), DATE_DISPLAY_FORMAT) : '';
  const toStr = to && isValid(new Date(to)) ? format(new Date(to), DATE_DISPLAY_FORMAT) : '';
  if (!fromStr && !toStr) return '';
  return `${fromStr} — ${toStr}`;
};

const MobileDateRangePickerField = (props) => {
  const { margin, field, form, onChange, inputFormat, ...other } = props;
  const [isDialogOpened, toggleDialog] = useToggle(false);
  const locale = getInitialLocale();
  const value = Array.isArray(field.value) ? field.value : [null, null];

  const handleAccept = (newValue) => {
    form.setFieldValue(field.name, newValue);

    if (onChange) {
      onChange(newValue);
    }

    toggleDialog(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale(locale)}>
      <FormControl margin={margin} fullWidth>
        <TextField
          label={t('selectPeriod')}
          value={formatDisplayValue(value)}
          onClick={() => toggleDialog(true)}
          InputProps={{
            readOnly: true,
            endAdornment: <DateRangeIcon color="action" />,
          }}
          fullWidth
        />
        <RangeCalendar
          open={isDialogOpened}
          value={value}
          onApply={handleAccept}
          onClear={() => form.setFieldValue(field.name, [])}
          onClose={() => toggleDialog(false)}
          title={t('selectPeriod')}
          startLabel={t('start')}
          endLabel={t('end')}
          applyLabel={t('apply')}
          cancelLabel={t('cancel')}
          clearLabel={t('reset')}
          {...other}
        />
      </FormControl>
    </LocalizationProvider>
  );
};

MobileDateRangePickerField.propTypes = {
  form: Type.object.isRequired,
  field: Type.object.isRequired,
  startText: Type.string,
  endText: Type.string,
  okText: Type.string,
  cancelText: Type.string,
  margin: Type.oneOf(['none', 'dense', 'normal']),
  onChange: Type.func,
};

MobileDateRangePickerField.defaultProps = {
  startText: t('start'),
  endText: t('end'),
  okText: t('apply'),
  cancelText: t('cancel'),
  margin: 'normal',
  onChange: undefined,
};

export default MobileDateRangePickerField;